<template>
    <div class="home d-flex flex-column fill-height">
        <Navigation/>
        <v-main class="grow">
            <v-container fluid class="fill-height align-start pb-0">
                <v-row justify="center" class="fill-height">
                    <v-col cols="12">
                        <v-card class="fill-height">
                            <CardTitle text="Bienvenue"/>
                            <v-card-text class="text-center">
                                <div class="body-1" style="z-index: 999; position: relative;">
                                    <p class="text-center font-weight-bold">Adhérer à <oncogite/>, c’est :</p>
                                    <ul class="mb-4" style="list-style-type: none;">
                                        <li>Devenir acteur de sa santé</li>
                                        <li>Faire partie d’une communauté cogiteuse</li>
                                        <li>Etre pris en charge par des professionnels experts</li>
                                        <li>Agir sur les décisions – plus nous serons nombreux, plus nous aurons du poids.</li>
                                        <li>Permettre à <oncogite/> de poursuivre ses actions grâce aux cotisations.</li>
                                    </ul>
                                    <p class="mb-n1"><oncogite/> est une association Loi 1901 et reconnue d’intérêt général depuis sa création en mai 2019.</p>
                                    <p>pour accompagner les patients et prendre en charge leurs troubles cognitifs</p>
                                    <p class="mb-n1">L'adhésion est facile et vous pouvez régler les 20€ annuel avec votre CB</p>
                                    <p>Le parcours de remédiation cognitive est offert par nos partenaires</p>
                                </div>
                                <div class="text-center mt-md-5">
                                    <v-btn color="primary" :to="{ name: 'payment-subscription' }" style="z-index: 999;">Finaliser mon adhésion</v-btn>
                                </div>
                            </v-card-text>
                            <v-footer fixed color="transparent" class="pb-7">
                                <v-img :src="require('@/assets/images/bandeau_bienvenue.png')" contain>
                                </v-img>
                            </v-footer>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </div>
</template>

<script>
export default {
    name: 'Welcome'
}
</script>
